module.exports = __webpack_public_path__ + "static/media/Large_Bottom_Link_Archive.9e0b4122.svg";